import { QueryClient } from '@tanstack/react-query';
import { DefaultQueryOptions } from './cache-config';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DefaultQueryOptions.staleTime,
      gcTime: DefaultQueryOptions.gcTime,
      retry: DefaultQueryOptions.retry,
      refetchOnWindowFocus: DefaultQueryOptions.refetchOnWindowFocus,
    },
  },
});
